import React from "react";
import { useIntl } from "react-intl";
import PropTypes from "prop-types";
import styled from "styled-components";

import NavItem from "./NavItem/NavItem";

const Nav = styled.nav`
  ${({ desktop, theme: { colors } }) => `
    flex-basis: 1;
    display: flex;
    flex-direction: ${!desktop ? "column" : "row"};
    justify-content: ${!desktop ? "space-between" : "center"};
    align-items: center;
    height: 100%;
    background-color: ${colors.darkGray};

    ${
      !desktop &&
      `
      padding: 30px 0px;
    `
    }
  `}
`;

const Ul = styled.ul`
  ${({ desktop }) => `
    display: flex;
    flex-direction: ${desktop ? "row" : "column"};
    justify-content: ${desktop ? "space-between" : "flex-start"};
    align-items: center;
    height: 100%;
    width: 100%;
  `}
`;

const NavItems = ({
  desktop,
  loggedIn,
  isActiveDictionary,
  inApp,
  toggleDrawer,
  routes,
}) => {
  const intl = useIntl();

  const links = (
    <>
      <Ul desktop={desktop}>
        {routes.map(({ id, text, to }) => (
          <NavItem
            key={id}
            to={to}
            isDisabled={inApp && !isActiveDictionary && id !== 1}
            desktop={desktop}
            toggleDrawer={toggleDrawer}
          >
            {intl.formatMessage({
              id: `NAVBAR.${text.toUpperCase()}`,
              defaultMessage: "",
            })}
          </NavItem>
        ))}
      </Ul>
      {!desktop && loggedIn && (
        <NavItem desktop={desktop} to="/logout" toggleDrawer={toggleDrawer}>
          {intl.formatMessage({
            id: `NAVBAR.LOGOUT`,
            defaultMessage: "",
          })}
        </NavItem>
      )}
    </>
  );

  return <Nav desktop={desktop}>{links}</Nav>;
};

NavItems.propTypes = {
  isActiveDictionary: PropTypes.any,
  inApp: PropTypes.bool,
  toggleDrawer: PropTypes.func,
  routes: PropTypes.array.isRequired,
};

NavItems.defaultProps = {
  isActiveDictionary: false,
  inApp: false,
  toggleDrawer: () => {},
};

export default NavItems;
